import { getCompanyModelType } from "#modules/quoteRequestLines/helpers/getCompanyModelType";

import { useCompany } from "./useCompany";

export const useCompanyModelType = () => {
  const { company } = useCompany();
  const modelType = getCompanyModelType(company);

  return modelType;
};
